import {AfterViewInit, Component, signal, ViewChild, ViewContainerRef} from '@angular/core';
import {ApiClient} from '../../api.service';
import {ActivatedRoute} from '@angular/router';
import {ServerResult} from '../../models/ServerResult';
import {CheckupProtocolSportReportBA} from '../../models/CheckupProtocolSportReportBA';

@Component({
    selector: 'app-layout-external',
    templateUrl: './layout-external.component.html',
    styleUrls: ['./layout-external.component.scss'],
    standalone: false
})
export class LayoutExternalComponent implements AfterViewInit {
    @ViewChild('external', {read: ViewContainerRef}) external!: ViewContainerRef;
    downloading = signal(false);

    constructor(private apiClient: ApiClient, private route: ActivatedRoute) {
    }

    resolveStatProtocol = (res: ServerResult<CheckupProtocolSportReportBA>) => {
        if (!res || !res.data || !res.data.details) throw new Error('Не полные данные');
        const {printType} = res.data.details;
        if (!printType) return;
        const component = protocolTypeToComponent[printType];
        setTimeout(() => {
            const inst = this.external.createComponent(component);
            inst.setInput('external', res);
            this.downloading.set(false);
        })
    }
    resolveDynProtocol = (res: ServerResult<CheckupProtocolSportReportBA[]>) => {
        if (!res || !res.data || res.data.length === 0) throw new Error('Не полные данные');
        const {printType} = res.data[0].details;
        if (!printType) return;
        const component = protocolTypeToDynComponent[printType];
        setTimeout(() => {
            const inst = this.external.createComponent(component);
            inst.setInput('external', res);
            this.downloading.set(false);
        })
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.downloading.set(true);
            const id = this.route.snapshot.paramMap.get('id');
            const {dyn} = this.route.snapshot.queryParams;

            if(dyn){
                console.log(dyn);
                return this.apiClient.getCheckupProtocolSportReportDynGuid([id,dyn])
                    .subscribe(this.resolveDynProtocol)
            }

            this.apiClient.getCheckupProtocolSportReportByGuid(id).subscribe(this.resolveStatProtocol);
        });
    }
}

export const protocolTypeToComponent = {
}
export const protocolTypeToDynComponent = {
}
